import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import productBadgeMessages from 'i18n/productBadgeMessages'

function useSearchLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const anywhereLabel = intl.formatMessage({
      id: 'kVUTD8LjFWYGCcXOICyq',
      defaultMessage: 'Anywhere',
      description: 'Label for the "Anywhere" search destination option when no specific location is selected',
    })

    const customerRatingToLabel: Record<string, string> = {
      7: intl.formatMessage({
        id: 'bo3I7OZsbnIxdgfFINtm',
        defaultMessage: 'Good',
        description: 'Customer rating category label for ratings of 7 and above',
      }),
      8: intl.formatMessage({
        id: 'g904KS_2uinGKwZLpmjL',
        defaultMessage: 'Very Good',
        description: 'Customer rating category label for ratings of 8 and above',
      }),
      9: intl.formatMessage({
        id: 'xQb__X2QpFfKBYX2wH0q',
        defaultMessage: 'Exceptional',
        description: 'Customer rating category label for ratings of 9 and above',
      }),
    }

    const limitedTimeLuxExclusive = intl.formatMessage(
      productBadgeMessages.limitedTimeLuxExclusiveLe,
    )

    const allLuxPlusRecentFilter = intl.formatMessage({
      id: 'u5dDCLygd29MyJuZKSbK',
      defaultMessage: 'All LuxPlus+ offers',
      description: 'Filter label for showing all LuxPlus+ offers in search results',
    })

    return {
      anywhereLabel,
      customerRatingToLabel,
      limitedTimeLuxExclusive,
      allLuxPlusRecentFilter,
    }
  }, [intl])
}

export default useSearchLabels
